import script from "./IconPlayButton.vue?vue&type=script&setup=true&lang=js"
export * from "./IconPlayButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__